import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

// For the More Action Item to have either href of action
interface MoreActionWithHref {
  href: string;
}

interface MoreActionWithAction {
  action: (...args: unknown[]) => void;
}

export type MoreActionsItem = (MoreActionWithAction | MoreActionWithHref) & {
  id: string;
  content: string;
  isDisabled?: boolean;
  predicate?: boolean;
  action?: (...args: unknown[]) => void;
  href?: string;
  ariaLabel?: string;
};

interface Props {
  actions: MoreActionsItem[];
  testId?: string;
  isLoading?: boolean;
}

const isAuthorized = (action: MoreActionsItem) => action.predicate === undefined || action.predicate === true;

export const MoreActions = ({ actions, testId, isLoading }: Props) => {
  const visibleActions = actions.filter(isAuthorized);

  if (isEmpty(visibleActions)) {
    return <></>;
  }

  return (
    <DropdownMenu
      testId={testId ?? 'more-action-menu'}
      position="bottom right"
      triggerType="button"
      triggerButtonProps={{
        appearance: 'subtle',
        className: 'trigger-button',
        iconBefore: <MoreIcon label="More" />,
        style: {
          marginLeft: '4px',
        },
      }}
      isLoading={isLoading}
    >
      <DropdownItemGroup>
        {visibleActions.map(({ href, action, id, content, isDisabled, ariaLabel }) => {
          return (
            <DropdownItem
              key={id}
              testId={`more-action-${id}`}
              {...(ariaLabel ? { 'aria-label': ariaLabel } : undefined)}
              {...(href ? { href } : undefined)}
              {...(action
                ? {
                    onClick: action,
                  }
                : undefined)}
              isDisabled={isDisabled ?? false}
            >
              {content}
            </DropdownItem>
          );
        })}
      </DropdownItemGroup>
    </DropdownMenu>
  );
};
